<template>
  <div class="oilMap">
    <div class="echartsBox">
      <EchartsComp :options="chart1_option" :dataObj="dataObj"></EchartsComp>
      <!-- :width="'298px'" -->
      <!-- :minHeight="'146px'" -->
    </div>
  </div>
</template>
<script>
// 引入图表组件
import EchartsComp from "@/components/EchartsComponent.vue";

export default {
  components: {
    EchartsComp,
  },
  props: {
    // 在线设备列表数据
    deviceList: {
      type: Array,
    },
    device: {
      type: Object,
    },
    lang: {
      type: String,
    },
  },
  watch: {
    // 初始化延迟渲染地图设备列表
    deviceList(a, b) {
      this.getEMONum();
    },
  },
  data() {
    return {
      // 第一个图表的数据
      chart1_option: {},
      dataObj: {},
    };
  },
  created() {},
  mounted() {
    this.getEMONum();
    this.initMap();
  },
  methods: {
    // 地图初始化
    initMap() {
      this.chart1_option = this.$EchartsData.chinaCharts();
    },
    getEMONum() {
      let devMap = this.deviceList.map((el) => {
        let devName = el.address.substring(0, 2);
        return devName;
      });
      this.dataObj = this.countDuplicates(devMap);
    },
    //各个省 设备的个数
    countDuplicates(arr) {
      let map = new Map();
      let uniqueArr = arr.reduce((accumulator, currentValue) => {
        if (!map.has(currentValue)) {
          map.set(currentValue, 1);
          accumulator.push(currentValue);
        } else {
          map.set(currentValue, map.get(currentValue) + 1);
        }
        return accumulator;
      }, []);

      let count = {};
      for (let [key, value] of map) {
        if (value > 1) {
          count[key] = value;
        }
      }

      return {
        uniqueArr: uniqueArr,
        count: count,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.oilMap {
  width: 100vw;
  height: 100vh;
  background: #00192e;
  display: flex;
  // padding: 36px 10px 20px 10px;
  padding-top: 6%;
  .echartsBox {
    width: 100%;
    height: 100%;
  }
}
</style>
